export default __webpack_public_path__ + "static/media/flag-eng.623a4f33.svg";